import { Card, Text } from "@radix-ui/themes";

export function AssociatedJiraTickets() {
  return (
    <Card className="w-full p-4 bg-white shadow-sm">
      <Text size="2" weight="bold" className="mb-2">
        Associated Jira Tickets
      </Text>
      <div className="space-y-3">
        <div className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-md">
          <div>
            <Text size="2" weight="medium">
              PROJ-123
            </Text>
            <Text size="1" className="text-gray-500">
              Database connection timeout
            </Text>
          </div>
          <div className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs">
            In Progress
          </div>
        </div>
        <div className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-md">
          <div>
            <Text size="2" weight="medium">
              PROJ-124
            </Text>
            <Text size="1" className="text-gray-500">
              API rate limiting implementation
            </Text>
          </div>
          <div className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
            Done
          </div>
        </div>
      </div>
    </Card>
  );
}
